import React, { Fragment, Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import Loader from "react-loaders";
import ProtectedRoute from "./routes/ProtectedRoute";
import { generateRoutesFromNav, getRouteRoles } from "./utils/routeGenerator";

const Login = lazy(() => import("./pages/LoginModern"));
const Forbidden = lazy(() => import("./pages/Forbidden"));


const Fallback = () => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(255,255,255,0.6)",
      zIndex: 2000,
    }}
  >
    <div className="spinner-border text-primary" role="status" aria-label="Loading" />
  </div>
);

const AppRouter = () => {
  const { isAuthenticated, roleType } = useAuth();
  const rootRedirect = isAuthenticated ? "/home" : "/login";
  return (
    <Fragment>
      <Routes>
        <Route
          path="/login"
          element={
            <Suspense fallback={<Fallback />}> 
              <Login />
            </Suspense>
          }
        />

        <Route
          path="/forbidden"
          element={
            <Suspense fallback={<Fallback />}> 
              <Forbidden />
            </Suspense>
          }
        />
        {/* All routes auto-generated from navigation items */}
        {generateRoutesFromNav()}

        <Route path="/" element={<Navigate to={rootRedirect} replace />} />
        <Route path="*" element={<Navigate to={rootRedirect} replace />} />
      </Routes>
    </Fragment>
  );
};

export default AppRouter;


